import React from 'react';
import Navbar from '../components/Layouts/Navbar';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';
import QrFlowHeader from '../components/QrFlow/QrFlowHeader';
import QrFlowAbout from '../components/QrFlow/QrFlowAbout';
import QrFlowShowcase from '../components/QrFlow/QrFlowShowcase';
import QrFlowFeatures from '../components/QrFlow/QrFlowFeatures';
import QrFlowPlatform from '../components/QrFlow/QrFlowPlatform';
import QrFlowUseCases from '../components/QrFlow/QrFlowUseCases';
import QrFlowCta from '../components/QrFlow/QrFlowCta';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';

const QrFlowProduct = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('qrFlow_page_title')}
                description={t('qrFlow_page_description')}
                canonical={`${baseUrl}/qr-flow/`}
                openGraph={{
                    url: `${baseUrl}/qr-flow/`,
                    title: t('qrFlow_page_ogTitle'),
                    description: t('qrFlow_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1080,
                            height: 1080,
                            alt: 'QRFlow',
                            type: 'image/png',
                        },
                    ],
                    siteName: 'Simplify Data',
                    locale: locale === 'en' ? 'en_US' : 'de_DE',
                    type: 'website',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('qrFlow_page_keywords'),
                    },
                ]}
            />

            <Navbar />
            <QrFlowHeader />
            <QrFlowAbout />
            <QrFlowShowcase />
            <QrFlowPlatform />
            <QrFlowFeatures />
            <QrFlowUseCases />
            <QrFlowCta />
            <SubscribeStyleOne />
            <Footer />
        </>
    );
};

export default QrFlowProduct;
